import React from "react";
import { Box } from "@mui/material";
import SurveyFormBeforeBooking from "./survey/SurveyFormBeforeBooking";

const RenderSurveys = ({
  surveys,
  setValue,
  setSurveyHasAnswered,
  selectedOffer,
  setSelectedOffer,
}) => {
  const onAddAnswer = (surveyId, skipped = false, respondent = null) => {
    let currentSurveys = selectedOffer.survey.map((element) => {
      if (element.id === surveyId) {
        return {
          ...element,
          hasanswer: true,
          skipped,
          respondent: {
            respondent_id: respondent,
            survey_id: element.id,
          },
        };
      }
      return element;
    });

    setSelectedOffer({
      ...selectedOffer,
      survey: currentSurveys,
    });
  };

  return (
    <div>
      {surveys.map((survey, surveykey) => {
        return (
          <Box key={surveykey}>
            <SurveyFormBeforeBooking
              surveyId={survey?.id}
              surveySlug={survey?.slug}
              surveyIsRequired={survey?.options?.survey_required ?? false}
              setSurveyHasAnswered={setSurveyHasAnswered}
              setValue={setValue}
              onAddAnswer={onAddAnswer}
            />
          </Box>
        );
      })}
    </div>
  );
};

export default RenderSurveys;
